import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/services/user.service';
import { UtilityService } from 'src/app/services/utility.service';
import {
  SSO_NO_PASSWORD_TO_RESET_COPY,
  isSsoSignInRequired
} from 'src/app/services/vive-api-errors';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ForgotPasswordComponent {
  private _cdr = inject(ChangeDetectorRef);
  constructor(
    private UserService: UserService,
    private UtilityService: UtilityService,
    private ToastService: ToastService,
    private route: ActivatedRoute
  ) {
    this.EmailRegex = this.UtilityService.getRegex('email');
  }

  Entry: { email: string } = { email: '' };
  EmailRegex: RegExp;
  isPasswordRequestSent: boolean = false;

  sendPasswordResetRequest() {
    const cleanedEmail = this.Entry.email.trim();
    if (!this.EmailRegex.test(cleanedEmail)) {
      throw this.ToastService.addErrorToast('Error', 'Invalid email address.', {
        returnError: true
      });
    }

    this.UserService.requestPasswordReset({ email: cleanedEmail }).subscribe({
      next: () => {
        this.isPasswordRequestSent = true;
        this._cdr.markForCheck();
      },
      // The interceptor toasts every other failure and leaves this one here.
      // Anything else is rethrown so it is still reported as unhandled.
      error: (error: unknown) => {
        if (isSsoSignInRequired(error)) {
          this.ToastService.addErrorToast(
            'Error',
            SSO_NO_PASSWORD_TO_RESET_COPY
          );
          return;
        }
        throw error;
      }
    });
  }
}
